// src/utils/constants.js
import { MapPin, MessageSquare, Wrench, Image as ImageIcon } from 'lucide-react';

export const LOGO_URL = "/logo.png";
export const WATERMARK_URL = "/watermark.png";

export const UPDATE_TYPES = {
  LOCATION: { 
    id: 'location', 
    icon: MapPin, 
    label: 'Lokalizacja',
    color: '#3B82F6',
    dotColor: 'bg-blue-500'
  },
  COMMENT: { 
    id: 'comment', 
    icon: MessageSquare, 
    label: 'Komentarz',
    color: '#6B7280',
    dotColor: 'bg-gray-500'
  },
  MODIFICATION: { 
    id: 'modification', 
    icon: Wrench, 
    label: 'Modyfikacja',
    color: '#F59E0B',
    dotColor: 'bg-amber-500'
  },
  PHOTO: { 
    id: 'photo', 
    icon: ImageIcon, 
    label: 'Zdjęcie',
    color: '#8B5CF6',
    dotColor: 'bg-purple-500'
  }
};